export default __webpack_public_path__ + "static/media/UploadIMG2.c4c4d1da.svg";